/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Part_Status_DeliveredInputs */

const en_part_status_delivered = /** @type {(inputs: Part_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered`)
};

const ja_part_status_delivered = /** @type {(inputs: Part_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配達済み`)
};

const fr_part_status_delivered = /** @type {(inputs: Part_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livré`)
};

const de_part_status_delivered = /** @type {(inputs: Part_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliefert`)
};

/**
* | output |
* | --- |
* | "Delivered" |
*
* @param {Part_Status_DeliveredInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const part_status_delivered = /** @type {((inputs?: Part_Status_DeliveredInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Part_Status_DeliveredInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_part_status_delivered(inputs)
	if (locale === "ja") return ja_part_status_delivered(inputs)
	if (locale === "fr") return fr_part_status_delivered(inputs)
	return de_part_status_delivered(inputs)
});